import { render, staticRenderFns } from "./ManifestacaoEspera.vue?vue&type=template&id=81de5fe4&"
import script from "./ManifestacaoEspera.vue?vue&type=script&lang=js&"
export * from "./ManifestacaoEspera.vue?vue&type=script&lang=js&"
import style0 from "./ManifestacaoEspera.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports